<script>
  import { navigate } from 'svelte-routing';
  export let to;
  navigate(to);
</script>
